import React from 'react'
import Radium from 'higher-order-components/configured-radium'
import {BASE_COPY} from 'constants/general-style'
import COLOR_PALETTE from 'constants/color-palette'

/**
 * Missing Component is rendered when a CMS component cannot be found on the frontend
 * (Since it is imported from HOC folder imports from folder indexs won't resolve. Hence /configured-radium)
 */
const MissingComponent = ({expectedComponentName}) => (
  <div style={style.base}>
    <span style={style.copy}>{expectedComponentName || 'Component'} not found</span>
  </div>
)

const style = {
  base: {
    background: COLOR_PALETTE.RED,
    display: 'inline-block',
    padding: '1em',
    margin: '0.5em',
  },
  copy: {
    ...BASE_COPY,
    color: COLOR_PALETTE.WHITE,
    fontWeight: 600,
  },
}

export default Radium(MissingComponent)



// WEBPACK FOOTER //
// ./src/components/missing-component/index.jsx